
export const Post=(link:string,body:string,tipo:string,token:string)=>
{
    var myHeaders = new Headers();
            myHeaders.append("Content-Type", tipo); 
            myHeaders.append("Authorization", "Bearer "+token);
            var requestOptions:any = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body:body
            };
            const datos= fetch(link, requestOptions)
            const prueba=datos.then(resultado=>resultado.json())
            const dato=prueba.then(resultado=>
                {
                    const contenido=resultado.access_token;
                    return contenido
                })
            return dato            
}

export const Post2=(link:string,body:any,tipo:string,token:string)=>
{
    
    var myHeaders = new Headers();
            myHeaders.append("Content-Type", tipo); 
            myHeaders.append("Authorization", "Bearer "+token);
            var requestOptions:any = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body:body
            };
            const datos= fetch(link, requestOptions)
            const prueba=datos.then(resultado=>resultado.json())
            const dato=prueba.then(resultado=>
                {
                    const contenido=resultado;
                    return contenido
                })
            return dato            
}

export const PostSinToken=(link:string,body:any,tipo:string)=>
    {
        
        var myHeaders = new Headers();
                myHeaders.append("Content-Type", tipo); 
                var requestOptions:any = {
                method: 'POST',
                headers: myHeaders,
                redirect: 'follow',
                body:body
                };
                const datos= fetch(link, requestOptions)
                const prueba=datos.then(resultado=>resultado.json())
                const dato=prueba.then(resultado=>
                    {
                        const contenido=resultado;
                        return contenido
                    })
                return dato            
    }

export const Get=(link:string,tipo:string,token:string)=>
{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", tipo);
    myHeaders.append("Authorization", "Bearer "+token);
    var requestOptions:any = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };
    const datos=fetch(link, requestOptions)
    const prueba=  datos.then(response => response.json())
    const envio=prueba.then(result =>
        {
            const contenido=result;
            return contenido}
        )
    .catch(error => {console.log(error);const contenido:any=[];return contenido}); 
    
    return envio
    
}
export const GetSinToken=(link:string,tipo:string)=>
    {
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", tipo);
        var requestOptions:any = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };
        const datos=fetch(link, requestOptions)
        const prueba=  datos.then(response => response.json())
        const envio=prueba.then(result =>
            {
                const contenido=result;
                return contenido}
            )
        .catch(error => {console.log(error);const contenido:any=[];return contenido}); 
        
        return envio
        
    }

export const Put=(link:string,tipo:string,token:string,cuerpo:string)=>
{
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", tipo);
    myHeaders.append("Authorization", "Bearer "+token);
    var requestOptions:any = {
    method: 'PUT',
    headers: myHeaders,
    redirect: 'follow',
    body:cuerpo
    };
    const datos=fetch(link, requestOptions)
    const prueba=  datos.then(response => response.json())
    const envio=prueba.then(result =>
        {
            const contenido=result;
            return contenido}
        )
    .catch(error => console.log(error)); 
    
    return envio
    
}

export const PostSinContent=(link:string,body:any,token:string)=>
{
    
    var myHeaders = new Headers();
            myHeaders.append("Authorization", "Bearer "+token);
            var requestOptions:any = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body:body
            };
            const datos= fetch(link, requestOptions)
            const prueba=datos.then(resultado=>resultado.json())
            const dato=prueba.then(resultado=>
                {
                    const contenido=resultado;
                    return contenido
                })
            return dato            
}

export const GetSinRetorno=(link:string,tipo:string,token:string)=>
{
    console.log(link)
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", tipo);
    myHeaders.append("Authorization", "Bearer "+token);
    var requestOptions:any = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };
    const datos=fetch(link, requestOptions)
    const prueba=  datos.then(response => console.log(response))
    
    
}

export const PostSinRetorno=(link:string,body:any,tipo:string,token:string)=>
{
    console.log(link)
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", tipo);
    myHeaders.append("Authorization", "Bearer "+token);
    var requestOptions:any = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow',
    body:body
    };
    const datos=fetch(link, requestOptions)
    const prueba=  datos.then(response => console.log(response))
    
    
}